module.exports = __webpack_public_path__ + "img/honor12.b90472eb.png";